import { useQuery } from '@tanstack/react-query'
import useParam from '../../../../shared/hooks/useParam'
import { polygonParam, datasetParam } from '../../query-params'
import { getDrawToolConfig, DrawToolResults, polygonToString } from './config'
import { getFetchUrl } from '../../../../services/getData'

const useDrawResultsQuery = (
  authorized: boolean,
  pageSize: number,
  clusters: boolean,
  page = 1,
) => {
  const [dataset] = useParam(datasetParam)
  const [polygon] = useParam(polygonParam)
  const polygonString = polygonToString(polygon?.polygon)
  const { endpoint, clusterFields, listFields, polygonKey } = getDrawToolConfig(dataset)

  return useQuery<DrawToolResults>({
    queryKey: ['drawResults', dataset, polygonString, pageSize, page],
    queryFn: ({ signal }) => {
      if (polygon) {
        const url = getFetchUrl(endpoint, undefined, {
          _count: (!clusters).toString(),
          _fields: (clusters ? clusterFields : listFields).join(','),
          _pageSize: pageSize.toString(),
          page: page.toString(),
          [`${polygonKey}[intersects]`]: polygonString,
        })

        return getDrawToolConfig(dataset).fetchResults(url, signal)
      }
      return { results: [], totalCount: 0, totalPages: 0 }
    },
    enabled: authorized,
  })
}

export default useDrawResultsQuery
